'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

exports.default = _react.PropTypes.oneOf([_senderTypes.AGENT, _senderTypes.VISITOR, _senderTypes.BOT, _senderTypes.SYSTEM]);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/prop-types/SenderTypePropType.js
// module id = 54
// module chunks = 2 3